import { render } from "./TeamingSpinner.vue?vue&type=template&id=1ac28b36&scoped=true"
import script from "./TeamingSpinner.vue?vue&type=script&lang=js"
export * from "./TeamingSpinner.vue?vue&type=script&lang=js"

import "./TeamingSpinner.vue?vue&type=style&index=0&id=1ac28b36&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1ac28b36"

export default script